import lazyRequire from "../../../util/lazyRequire";
import { log } from "../../../util/log";
const getLogLevel = (level) => {
    switch (level) {
        case 0:
            return "debug";
        case 1:
            return "debug";
        case 2:
            return "info";
        case 3:
            return "warn";
        case 4:
            return "error";
        case 5:
            return "error";
    }
    return "debug";
};
export class VortexModInstallerLogger {
    fomod;
    mLogger;
    constructor() {
        this.fomod = lazyRequire(() => require("@nexusmods/fomod-installer-native"));
        this.mLogger = new this.fomod.NativeLogger(this.log);
    }
    useVortexFunctions = () => {
        this.mLogger.setCallbacks();
    };
    useLibraryFunctions = () => {
        this.fomod.NativeLogger.setDefaultCallbacks();
    };
    /**
     * Callback
     */
    log = (level, message) => {
        const logLevel = getLogLevel(level);
        log(logLevel, message);
    };
}
